import FormatDateTime from 'components/utils/Formatters/FormatDateTime'
import FormatDecimal from 'components/utils/Formatters/FormatDecimal'
import Plural from 'components/utils/Formatters/Plural'
import { useAppSelector } from 'hooks/reduxHooks'
import useLoyaltyUserBenefitView from 'loyalty/hooks/useLoyaltyUserBenefitView'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import React, { ComponentProps } from 'react'
import LoyaltyTierBenefitMessageBanner from './LoyaltyTierBenefitMessageBanner'
import getIsLoyaltyLeadRegion from 'loyalty/selectors/getIsLoyaltyLeadRegion'
import FormatCurrency from 'components/Common/FormatCurrency'

type InheritedLoyaltyTierBenefitMessageBannerProps = Pick<ComponentProps<typeof LoyaltyTierBenefitMessageBanner>, 'flat' | 'icon'>

interface Props extends InheritedLoyaltyTierBenefitMessageBannerProps {
  benefitType: App.LoyaltyBenefitType
  /**
   * @default benefit's availability
   */
  benefitAvailability?: number
}

function LoyaltyTierBenefitAvailabilityMessageBanner({
  benefitType,
  benefitAvailability,
  ...rest
}: Props) {
  const displayTier = useAppSelector(getLoyaltyDisplayTier)
  const statusReviewDate = useAppSelector(state => state.loyalty.account.data?.statusReviewDate)
  const benefitView = useLoyaltyUserBenefitView(benefitType)
  const isLeadLoyaltyRegion = useAppSelector(getIsLoyaltyLeadRegion)

  if (!benefitView) return null

  const availability = benefitAvailability ?? benefitView.availability

  if (!availability) return null

  return <LoyaltyTierBenefitMessageBanner
    tier={displayTier}
    benefitType={benefitType}
    density="compact"
    endContent={!!statusReviewDate && <div>
      Expires <b><FormatDateTime value={statusReviewDate} month="short" year="numeric" /></b>
    </div>}
    {...rest}
  >
    Available to redeem{' '}
    {benefitType !== 'discounted_insurance' && <b>
      {availability === Infinity && 'unlimited'}
      {availability !== Infinity && <>x<FormatDecimal value={availability} /></>}
      {(benefitType === 'travelshoot_credit' || benefitType === 'tour_exp_credit') && !!benefitView.benefit.value?.amount && <>
        {isLeadLoyaltyRegion && <>{' '}<FormatCurrency value={benefitView.benefit.value?.amount ?? 0} format="dynamic" /> <Plural count={availability} singular="voucher" plural="vouchers" /></>}
        {!isLeadLoyaltyRegion && <>{' '}<Plural count={availability} singular="voucher" plural="vouchers" /></>}
      </>}
    </b>}
    {benefitType === 'discounted_insurance' && <b>{benefitView.benefit.value?.amount}% off</b>}
  </LoyaltyTierBenefitMessageBanner>
}

export default LoyaltyTierBenefitAvailabilityMessageBanner
